// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"9477771f","485":"6fcf6338","536":"ba2aa9ac"}[chunkId] + ".chunk.css";
};